import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { Base, Interactive } from '../Base';
import { SrOnly } from '../Helper';
import Svg from '../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Tag-root_3UI7k",
  "themeGrey": "Tag-themeGrey_2YKcx",
  "themeWhite": "Tag-themeWhite_1QVnG",
  "themeAccent": "Tag-themeAccent_1yV9u",
  "label": "Tag-label_23dia",
  "static": "Tag-static_3cmB7",
  "dismissible": "Tag-dismissible_2K1xX",
  "focusable": "Tag-focusable_2Faqj",
  "hoverable": "Tag-hoverable_3iJk8",
  "active": "Tag-active_3A65O",
  "closeButton": "Tag-closeButton_BQ2M-",
  "closeIcon": "Tag-closeIcon_1T8kU"
};
function Tag({
  theme = 'grey',
  to,
  href,
  children,
  dismissible,
  active,
  disabled,
  readOnly,
  onClick,
  onDismiss,
  className,
  closeButtonProps,
  ...extraProps
}) {
  const interactive = Boolean(to || href || onClick);
  const isDismissible = dismissible && !disabled && !readOnly;
  const interactiveProps = (() => {
    if (interactive && disabled) return {
      tagName: 'button',
      disabled
    };
    if (interactive && readOnly) return {
      tagName: 'button'
    };
    if (interactive) return {
      to,
      href,
      onClick,
      interactive
    };
    return {
      tagName: 'span'
    };
  })();
  const rootClasses = clsx(styles.root, {
    [styles.themeGrey]: theme === 'grey',
    [styles.themeWhite]: theme === 'white',
    [styles.themeAccent]: theme === 'accent' || theme === 'purple'
  }, className);
  const labelClasses = clsx(styles.label, {
    [styles.static]: !isDismissible,
    [styles.dismissible]: isDismissible,
    [styles.focusable]: interactive && !disabled,
    [styles.hoverable]: interactive && !disabled && !readOnly,
    [styles.active]: active
  });
  return /*#__PURE__*/_jsxs(Base, {
    size: "small",
    className: rootClasses,
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Interactive, {
      title: typeof children === 'string' ? children : undefined,
      boxSizing: "border",
      paddingY: "none",
      flex: true,
      flexAlignItemsCenter: true,
      weight: "regular",
      color: "base",
      className: labelClasses,
      ...interactiveProps,
      children: /*#__PURE__*/_jsx(Base, {
        tagName: "span",
        overflow: "truncate",
        children: children
      })
    }), isDismissible ? /*#__PURE__*/_jsx(CloseButton, {
      onClick: onDismiss,
      ...closeButtonProps
    }) : null]
  });
}
function CloseButton(props) {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "button",
    type: "button",
    flex: true,
    flexAlignItemsCenter: true,
    flexJustifyCenter: true,
    border: "none",
    padding: "none",
    interactive: true,
    className: styles.closeButton,
    ...props,
    children: [/*#__PURE__*/_jsx(Svg, {
      name: "miniCrossBold",
      focusable: "false",
      className: styles.closeIcon
    }), /*#__PURE__*/_jsx(SrOnly, {
      children: __('Dismiss')
    })]
  });
}
export default Tag;